import React, { useState, Fragment, useMemo, useEffect } from "react";
import { Popover, Switch, Tooltip, Modal } from "antd";
import Axios from "axios";
import moment from "moment";
import {
  AiOutlineCheckCircle,
  AiOutlineFileExcel,
  AiOutlineInfoCircle,
  AiOutlineRight,
} from "react-icons/ai";
import { IoMdPricetag } from "react-icons/io";
import {
  LongButton,
  MainBlock,
  MiniBlock,
} from "../../../components/common/Buttons";
import { SerialNumberBlock } from "../../../components/common/SerialNumberModal";
import Spinner from "../../../components/common/Spinner";
import { Divs } from "../../../components/common/StyledComponents";
import ModalSpecial from "../../../components/Layout/Modals/ModalSpecial";
import {
  antdMessageError,
  antdMessageSuccess,
  exportDocument,
  prettyDateFormat,
  returnEuroString,
  toFixedNumber,
} from "../../../helpers/Utils";
import RenderComments from "./RenderComments";
import RenderSms from "./RenderSms";
import OrderHistory from "../../../components/common/GlobalModals/Orders/editModal/OrderHistory";
import { have_product_reference } from "../../../helpers/OrdersFunctionsGlobal";
import { formatDateTime } from "../../../utils/date";
import { ButtonSecondary } from "../../../components/globals";
import PickupLeasingComponent from "./PickupLeasingComponent";
import { GoPrimitiveDot } from "react-icons/go";
import { colors } from "../../../utils/colors";
import { fetcherPickups } from "../../../utils/react-query";
import { useMutation, useQuery, useQueryClient } from "react-query";
import DocumentItem from "../../../components/common/GlobalModals/Orders/editModal/AttachOrderDocument/DocumentItem";
import { getLocalStorage, setLocalStorage } from "../../../utils/localstorage";
import { usePickupState } from "../../../context/PickupContext";
import { removeDuplicates } from "../../../helpers/array";
import { IconExclamation } from "../../../components/Layout/Icons";
import { Checkbox } from "antd";

const { confirm } = Modal;

export const PickupsOrderShow = ({ close, showOrderModal }) => {
  const {
    isLoading,
    data: { success = false, data = {} } = {},
    refetch,
  } = useQuery({
    queryKey: ["requests", { record_id: showOrderModal.record_id }],
    queryFn: fetcherPickups,
    cacheTime: 0,
  });

  const { user } = usePickupState();
  const [showPrepared, setShowPrepared] = useState(false);
  const [opennedModalTables, setOpennedModalTables] = useState({
    order_info: true,
    order_goods: true,
    order_status: true,
    order_delivery: true,
    order_payment: true,
    order_serial_number: true,
    leasing: true,
    comments: true,
    comments_store: true,
    sms_sendings: true,
    order_documents: true,
  });
  const [checkedBoxes, setCheckedBoxes] = React.useState([]);
  const [shipmentOrderRowIds, setShipmentOrderRowIds] = React.useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);
  const PickupStatus = {
    UNPREPARED: "unprepared",
    CLIENT_CALLED: "client_called",
    PREPARED: "prepared",
    GIVE_AWAY: "give_away",
    CANCELED: "canceled",
    WANTS_TO_CANCEL: "wants_to_cancel",
  };

  useEffect(() => {
    getLocalStorage("pickup_request_modal_show").then(
      (res) => res && setOpennedModalTables(res)
    );
  }, []);

  React.useEffect(() => {
    if (Object.keys(checkedBoxes).length !== 0) {
      const shipmentOrderRowIdsArray = Object.keys(checkedBoxes).filter(
        (key) => checkedBoxes[key]
      );
      setShipmentOrderRowIds(() => shipmentOrderRowIdsArray.join(","));
    }
  }, [checkedBoxes]);

  const updateOpennedModalTables = (name) => {
    setOpennedModalTables((prev) => {
      const buildedObj = { ...prev, [name]: !prev[name] };
      setLocalStorage("pickup_request_modal_show", buildedObj);
      return buildedObj;
    });
  };

  const onExportDocumentClick = () => {
    exportDocument(
      `/pickups/requests/download_pickup_at_store?shipment_id=${shipment.id}&shipment_order_row_ids=` +
      shipmentOrderRowIds,
      `pickup_at_store${id_order}.pdf`,
      "POST"
    );
  };

  const mutationOrder = useMutation({
    mutationFn: (variables) => {
      return Axios.put(`/pickups/requests/update_order_row`, {
        ...variables,
      }).then((res) => res.data);
    },
    onSuccess: async () => {
      refetch();
      antdMessageSuccess();
      return true;
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.message);
      return false;
    },
  });

  const mutationPUTProductStatus = useMutation({
    mutationFn: (products) =>
      Axios({
        url: `/pickups/requests/update_rows_status`,
        method: "PUT",
        params: {
          status: products.status,
          ids: products.ids,
        },
      }).then((res) => res.data),
    onSuccess: () => {
      refetch();
      antdMessageSuccess();
    },
    onError: (error) => antdMessageError(error?.response?.data?.message),
  });

  if (!data || Object.entries(data).length == 0 || isLoading) {
    return (
      <ModalSpecial text={""} handleSave={() => { }} onClose={close}>
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "100%" }}
        >
          <Spinner identifier={"technorama"} />
        </div>
      </ModalSpecial>
    );
  } else if (!data.shipment || !success) {
    const no_shipment = <div></div>;
    return (
      <ModalSpecial text={no_shipment} handleSave={() => { }} onClose={close}>
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "100%" }}
        >
          Nerasta siunta.
        </div>
      </ModalSpecial>
    );
  }

  const {
    shipping_address,
    billing_address,
    payment,
    total_shipping,
    // carrier,
    id,
    id_order,
    sms_sendings,
    payments,
    waiting_payments,
    order_histories,
    order_cart_rules,
    comments,
    // shipments,
    order_invoices,
    order_documents,
    leasing_advance,
    leasing_number,
    leasing_discount,
    leasing_cod,
    remark: note_from_client,
    "order_with_leasing?": order_with_leasing,
  } = data.order;

  const { status, finalized_at, pickup_user, shipment, order } = data;

  const disabled =
    typeof user?.has_actions == "boolean" ? !user?.has_actions : true;

  const shipment_total_price = shipment?.shipment_order_rows?.reduce(
    (cur, acc) =>
      (+acc.price || acc.order_row?.unit_price_tax_incl || 0) *
      (+acc.quantity || +acc.order_row?.quantity || 0) +
      cur,
    0
  );

  const total_price =
    order?.order_rows.length > shipment?.order_rows.length
      ? shipment_total_price
      : order.total_price;

  const isShipmentTotalPrice = shipment_total_price == total_price;

  const dangerColor = () => {
    const total = toFixedNumber(
      payments.reduce((acc, cur) => +acc + +cur.price, 0)
    );
    const totalPrice = total_price;
    if (+totalPrice == +total) {
      return <span className="font-weight-bold text-black">{total}</span>;
    }
    return <span className="font-weight-bold text-danger">{total}</span>;
  };

  const unique_order_cart_rules = removeDuplicates(
    shipment.shipment_order_rows.map((sor) => sor.order_row?.order_cart_rule_id)
  ).filter(Number);
  // const filtered_order_cart_rules =
  //   unique_order_cart_rules.length == 0
  //     ? []
  //     : order_cart_rules.filter((ocr) =>
  //         unique_order_cart_rules.includes(ocr.id)
  //       );
  const filtered_order_cart_rules = order_cart_rules?.filter(
    (rule) => rule.deleted_at === null
  );

  const productStatus = (status) => {
    switch (status) {
      case PickupStatus.UNPREPARED:
        return "Nesuruošta";
      case PickupStatus.CLIENT_CALLED:
        return "Iškviestas klientas";
      case PickupStatus.PREPARED:
        return "Suruošta";
      case PickupStatus.GIVE_AWAY:
        return "Atiduota";
      case PickupStatus.CANCELED:
        return "Atšauktas";
      case PickupStatus.WANTS_TO_CANCEL:
        return "Klientas nori atšaukti";
      default:
        return "Nesuruošta";
    }
  };

  function formatDate(date) {
    const formattedDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")} ${String(
      date.getHours()
    ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;

    return formattedDate;
  }

  const getCheckedIds = () => {
    return Object.keys(checkedBoxes).filter((id) => checkedBoxes[id]);
  };

  const onCancelHandler = () => {
    mutationPUTProductStatus.mutate({
      ids: getCheckedIds(),
      status: PickupStatus.CANCELED,
    });
    setCheckedBoxes({});
    setSelectedStatus(null);
  };

  const onGivenHandler = () => {
    mutationPUTProductStatus.mutate({
      ids: getCheckedIds(),
      status: PickupStatus.GIVE_AWAY,
    });
    setCheckedBoxes({});
    setSelectedStatus(null);
  };

  const onSummonCustomerlHandler = () => {
    setCheckedBoxes({});
    setSelectedStatus(null);
  };

  const onPreparedHandler = () => {
    mutationPUTProductStatus.mutate({
      ids: getCheckedIds(),
      status: PickupStatus.PREPARED,
    });
    setCheckedBoxes({});
    setSelectedStatus(null);
  };

  const unselectAllCheckboxes = (shipmentId) => {
    setCheckedBoxes((prevCheckedBoxes) => ({
      ...prevCheckedBoxes,
      [shipmentId]: {},
    }));
  };

  const handleCheckboxChange = (event, id, status) => {
    const arrangedRows = arrangeRows(shipment.shipment_order_rows);

    setCheckedBoxes((prev) => {
      const updated = { ...prev, [id]: event.target.checked };

      const currentItemOrderRowId = arrangedRows.find((item) => item.id === id)
        ?.order_row.id;

      if (event.target.checked) {
        const childItems = arrangedRows.filter(
          (item) => item.order_row?.parent_id === currentItemOrderRowId
        );
        childItems.forEach((child) => {
          updated[child.id] = true;
        });
      }

      if (!event.target.checked) {
        const childItems = arrangedRows.filter(
          (item) => item.order_row?.parent_id === currentItemOrderRowId
        );
        childItems.forEach((child) => {
          updated[child.id] = false;
        });
      }

      const allUnchecked = !Object.values(updated).some((checked) => checked);

      if (allUnchecked) {
        setSelectedStatus(null);
      } else if (selectedStatus === null) {
        setSelectedStatus(status);
      }

      return updated;
    });
  };

  const isAnyCheckboxChecked = () => {
    return Object.values(checkedBoxes).some(Boolean);
  };

  const getCheckedItemIds = () => {
    return Object.keys(checkedBoxes).filter((itemId) => checkedBoxes[itemId]);
  };

  const arrangeRows = (shipment_order_rows) => {
    const arrangedRows = [];
    let parentRows, childRows;

    parentRows = shipment_order_rows.filter(
      (item) => item.order_row?.product_reference !== "{}"
    );

    childRows = shipment_order_rows.filter(
      (item) =>
        item.order_row?.parent_id !== null &&
        item.order_row?.product_reference === "{}"
    );

    parentRows = parentRows.map((parent) => ({
      ...parent,
      order_row: { ...parent.order_row, isParent: true },
    }));

    childRows = childRows.map((child) => ({
      ...child,
      order_row: { ...child.order_row, isParent: false },
    }));

    parentRows.forEach((parent) => {
      const hasChildren = childRows.some(
        (child) => child.order_row?.parent_id === parent.order_row?.id
      );

      if (hasChildren) {
        parent.order_row.isParent = true;
      }

      arrangedRows.push(parent);
      childRows.forEach((child) => {
        if (child.order_row?.parent_id === parent.order_row?.id) {
          arrangedRows.push(child);
        }
      });
    });

    return arrangedRows;
  };

  const totalCartDiscountSum = filtered_order_cart_rules.reduce((acc, item) => {
    if (item?.id_product === null) {
      return acc + parseFloat(item?.total);
    }
    return acc;
  }, 0);

  const totalProductSum =
    shipment?.shipment_order_rows
      .filter((row) => row?.order_row?.product_reference !== "{}")
      .reduce((acc, row) => acc + parseFloat(row.price), 0) || 0;

  // const totalProductSum =
  //   shipment?.shipment_order_rows.reduce(
  //     (acc, row) => acc + parseFloat(row.price),
  //     0
  //   ) || 0;

  const distributedDiscountCalculation = totalCartDiscountSum / totalProductSum;

  function calculateFinalPrice(distributedDiscountCalculation, price) {
    const discountRate = parseFloat(distributedDiscountCalculation);

    const discountedAmount = price * discountRate;

    const finalPrice = price - discountedAmount;

    return finalPrice.toFixed(2);
  }

  return (
    <ModalSpecial
      text={
        <TopBar
          record_id={showOrderModal.record_id}
          status={status}
          finalized_at={finalized_at}
          pickup_user={pickup_user}
          shipment={shipment}
          id_order={id_order}
          billing_address={billing_address}
          sms_sendings={sms_sendings}
          refetch={refetch}
          user={user}
        />
      }
      handleSave={() => { }}
      onClose={close}
    >
      <div className="row">
        <div className="col-6">
          <Fragment>
            <Divs className="container-title-block">
              <MainBlock
                color={"#ffa800"}
                action={opennedModalTables.order_info}
                onChange={() => updateOpennedModalTables("order_info")}
              >
                Užsakymo informacija
              </MainBlock>
            </Divs>
            {opennedModalTables.order_info && (
              <Divs className="mt-3 mb-4">
                <>
                  <div className="col-12 row" style={{ margin: 0 }}>
                    <Divs className="col-6" style={{ width: "50%" }}>
                      <div className="d-flex justify-content-between align-items-center font-weight-bold mb-3">
                        <span>Pristatymo informacija</span>
                      </div>
                      <ul className="list-style-none text-sm">
                        <li>{shipping_address.street}</li>
                        <li>
                          {shipping_address.city},{" "}
                          {shipping_address.postal_code}
                        </li>
                      </ul>
                    </Divs>
                    <Divs
                      className="col-6"
                      style={{
                        width: "50%",
                        borderLeft: "1px solid #e3e3e3",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center font-weight-bold mb-3">
                        <span className="d-flex align-items-center">
                          <span>Mokėtojo informacija</span>
                        </span>
                      </div>

                      <BillingAddressComponent
                        disabled={disabled}
                        order_invoices={order_invoices}
                        billing_address={billing_address}
                        pickup_request_id={showOrderModal.record_id}
                        pickup_address_id={shipment.pickup_address_id}
                        order_rows={shipment.shipment_order_rows}
                      />
                    </Divs>
                  </div>
                  <Divs className="mt-3 mb-4">
                    <OrderTotalComponent
                      total_price={total_price}
                      payments={payments}
                      order_with_leasing={order_with_leasing}
                      isShipmentTotalPrice={isShipmentTotalPrice}
                    />
                    {note_from_client && (
                      <Fragment>
                        <div className="d-flex justify-content-start align-items-center font-weight-bold text-danger my-3">
                          <AiOutlineInfoCircle
                            className="text-danger mr-2"
                            style={{ fontSize: 17 }}
                          />{" "}
                          Kliento pastaba: {note_from_client}
                        </div>
                      </Fragment>
                    )}
                    {!!shipment?.shipment_address?.comment && (
                      <div className="my-3">
                        <div
                          className="d-flex justify-content-start align-items-center font-weight-bold"
                          style={{ fontWeight: 500 }}
                        >
                          <AiOutlineInfoCircle
                            className="mr-1"
                            style={{
                              fontSize: 17,
                              color: colors["technorama"],
                            }}
                          />{" "}
                          Pastaba
                        </div>
                        <div className="ml-4">
                          {shipment?.shipment_address?.comment}
                        </div>
                      </div>
                    )}
                    {filtered_order_cart_rules.length > 0 && (
                      <div className="my-3">
                        <div className="font-weight-bold">
                          <IoMdPricetag
                            className="text-orange mr-1"
                            style={{ fontSize: 17 }}
                          />
                          Nuolaidos:{" "}
                        </div>
                        {filtered_order_cart_rules.map(
                          (order_cart_rule, idx) => (
                            <p className="mb-0 ml-4" key={idx}>
                              {idx + 1}) {order_cart_rule.title}
                              {" - "}
                              {returnEuroString(order_cart_rule.total)}
                            </p>
                          )
                        )}
                      </div>
                    )}
                  </Divs>

                  <MiniBlock
                    color={"#ffcc69"}
                    action={opennedModalTables.order_goods}
                    onChange={() => updateOpennedModalTables("order_goods")}
                  >
                    Prekės
                  </MiniBlock>
                  {opennedModalTables.order_goods && (
                    <Divs>
                      <div className="table-responsive bg-silver">
                        <div
                          className="col-12"
                          style={{
                            marginBottom: "1rem",
                          }}
                        >
                          <table
                            className="table table-sm table-border-bottom"
                            style={{ marginBottom: "0px!important" }}
                          >
                            <tbody>
                              {arrangeRows(shipment.shipment_order_rows).map(
                                (e) => {
                                  const date = new Date(e.updated_at);
                                  const formattedDate = formatDate(date);
                                  const pickupStatus =
                                    e.pickup_status || PickupStatus.UNPREPARED;
                                  const disabled =
                                    pickupStatus !== selectedStatus &&
                                    selectedStatus !== null;
                                  const productReference =
                                    e.order_row?.product_reference;
                                  const hasProductReference =
                                    productReference &&
                                    have_product_reference(productReference);
                                  const quantity = Math.floor(
                                    e?.quantity || e.order_row?.quantity
                                  );
                                  const price = returnEuroString(
                                    e.price || e.order_row?.unit_price_tax_incl
                                  );
                                  const title =
                                    e.title || e.order_row?.product_name;
                                  if (e.order_row.product_reference === "{}") {
                                    return null;
                                  }

                                  return (
                                    <Fragment key={`rows_${e.id}`}>
                                      <tr>
                                        <td>
                                          <Checkbox
                                            className="mr-1"
                                            checked={
                                              checkedBoxes[e.id] || false
                                            }
                                            onChange={(event) =>
                                              handleCheckboxChange(
                                                event,
                                                e.id,
                                                pickupStatus
                                              )
                                            }
                                            disabled={
                                              disabled ||
                                              e.pickup_status ===
                                              PickupStatus.CANCELED
                                            }
                                          />
                                        </td>
                                        <td
                                          colSpan={2}
                                          className="font-weight-bold"
                                          style={{ fontSize: "0.8rem" }}
                                        >
                                          {hasProductReference ? (
                                            productReference
                                          ) : (
                                            <div className="text-center m-auto">
                                              <AiOutlineCheckCircle className="text-success mr-1" />
                                            </div>
                                          )}
                                        </td>
                                        <td colSpan={3}>
                                          <span
                                            className="font-weight-bold"
                                            style={{ fontSize: "0.8rem" }}
                                          >
                                            &nbsp;*&nbsp;
                                            <span
                                              className={
                                                e.manual
                                                  ? "border-bottom border-danger"
                                                  : null
                                              }
                                            >
                                              {title}
                                            </span>{" "}
                                          </span>
                                        </td>
                                        <td>
                                          {hasProductReference && (
                                            <Switch
                                              disabled={true}
                                              checkedChildren="S/N"
                                              unCheckedChildren="S/N"
                                              checked={
                                                e.order_row
                                                  .required_serial_number
                                              }
                                              onChange={() => { }}
                                            />
                                          )}
                                        </td>
                                        <td style={{ fontSize: "0.8rem" }}>
                                          {quantity}
                                        </td>
                                        <td colSpan={2}>
                                          {e.order_row?.product_reference !==
                                            "{}"
                                            ? calculateFinalPrice(
                                              distributedDiscountCalculation,
                                              parseFloat(price)
                                            )
                                            : price}
                                        </td>
                                      </tr>

                                      {arrangeRows(
                                        shipment.shipment_order_rows
                                      ).map((child) => {
                                        console.log(child);
                                        if (
                                          child.order_row?.parent_id !==
                                          e.order_row?.id
                                        ) {
                                          // Skip if it's not a child of the current parent
                                          return null;
                                        }
                                        const childQuantity = Math.floor(
                                          child.quantity || child?.order_row?.quantity ||
                                          e.order_row?.quantity
                                        );
                                        const childPrice = returnEuroString(
                                          child.price || child?.order_row?.product_price ||
                                          e.order_row?.unit_price_tax_incl
                                        );
                                        const childTitle =
                                          child?.title || child?.order_row?.product_name ||
                                          e.order_row?.product_name;
                                        return (
                                          <tr>
                                            <td></td>
                                            <td
                                              colSpan={2}
                                              className="font-weight-bold"
                                              style={{ fontSize: "0.8rem" }}
                                            >
                                              <div className="text-center m-auto">
                                                <AiOutlineCheckCircle className="text-success mr-1" />
                                              </div>
                                            </td>
                                            <td colSpan={3}>
                                              <span
                                                className="font-weight-bold"
                                                style={{ fontSize: "0.8rem" }}
                                              >
                                                &nbsp;*&nbsp;
                                                <span
                                                  className={
                                                    child.manual
                                                      ? "border-bottom border-danger"
                                                      : null
                                                  }
                                                >
                                                  {childTitle}
                                                </span>{" "}
                                              </span>
                                            </td>
                                            <td></td>
                                            <td style={{ fontSize: "0.8rem" }}>
                                              {childQuantity}
                                            </td>
                                            <td colSpan={2}>
                                              {parseFloat(childPrice)}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                      <tr>
                                        <td colSpan={10}>
                                          <div className="order-status-block">
                                            <AiOutlineInfoCircle
                                              className="icon-grey mr-2"
                                              style={{ fontSize: 17 }}
                                            />
                                            <p className="order-status-block-status mr-2">
                                              {productStatus(e?.pickup_status)}
                                            </p>
                                            <p className="order-status-block-info">
                                              {pickup_user?.title || ""}
                                              {" " + formattedDate}
                                            </p>
                                          </div>
                                        </td>
                                      </tr>
                                    </Fragment>
                                  );
                                }
                              )}
                            </tbody>
                          </table>
                          <div className="mt-2 mb-1 d-flex">
                            {isAnyCheckboxChecked() &&
                              (selectedStatus === PickupStatus.UNPREPARED ||
                                selectedStatus === PickupStatus.PREPARED) ? (
                              <Popover
                                placement="bottom"
                                onOpenChange={(val) => setShowPrepared(val)}
                                onClick={() => {
                                  setShowPrepared((prev) => !prev);
                                }}
                                open={showPrepared}
                                content={
                                  showPrepared ? (
                                    <RenderSms
                                      id={data.id}
                                      enableOnSendSmSClick={true}
                                      onSendSmSClick={() =>
                                        onSummonCustomerlHandler()
                                      }
                                      phoneNumber={billing_address.phone}
                                      checkedIds={getCheckedIds()}
                                      shipping_address_street={`${shipment.shipment_address.address}, ${shipment.shipment_address.city}`}
                                      orderId={data?.order?.id_order}
                                      shipments={shipment?.shipment_order_rows}
                                      sms_sendings={sms_sendings}
                                      chekedItemsId={getCheckedItemIds()}
                                      mode="Simple"
                                      closePopover={() =>
                                        setShowPrepared(false)
                                      }
                                    />
                                  ) : (
                                    ""
                                  )
                                }
                                trigger="click"
                              >
                                <button
                                  className="btn btn-sm float-left mr-1 btn-outline-warning btn-outline-orange call-client-button"
                                  onClick={() => { }}
                                >
                                  Suruošta
                                </button>
                              </Popover>
                            ) : (
                              <button
                                className="btn btn-sm float-left mr-1 btn-outline-warning btn-outline-orange call-client-button"
                                onClick={() => { }}
                                disabled={
                                  !isAnyCheckboxChecked() ||
                                  (PickupStatus.UNPREPARED !== selectedStatus &&
                                    PickupStatus.PREPARED !== selectedStatus)
                                }
                              >
                                Suruošta
                              </button>
                            )}

                            <button
                              className="btn btn-sm float-left mr-1 btn-outline-warning btn-outline-orange"
                              onClick={() => onGivenHandler()}
                              disabled={
                                !isAnyCheckboxChecked() ||
                                (PickupStatus.CLIENT_CALLED !== selectedStatus &&
                                  !(user?.can_handover_without_prepared &&
                                    [PickupStatus.UNPREPARED, PickupStatus.PREPARED].includes(selectedStatus)))
                              }
                            >
                              Atiduota
                            </button>
                            {user?.is_admin && (
                              <button
                                className="btn btn-sm float-left mr-1 btn-danger"
                                onClick={() => onCancelHandler()}
                                disabled={
                                  !isAnyCheckboxChecked() ||
                                  PickupStatus.GIVE_AWAY === selectedStatus
                                }
                              >
                                Atšaukti
                              </button>
                            )}

                            <ButtonSecondary
                              style={{
                                width: "auto",
                              }}
                              disabled={
                                !isAnyCheckboxChecked() ||
                                PickupStatus.UNPREPARED === selectedStatus
                              }
                              className="btn btn-sm btn-primary mr-2"
                              onClick={() => onExportDocumentClick()}
                              bgColor={colors["orange"]}
                              bgActiveColor={colors["orange"]}
                            >
                              Atidavimo dokumentas
                            </ButtonSecondary>
                          </div>
                        </div>
                      </div>
                    </Divs>
                  )}

                  {shipment.shipment_order_rows
                    .filter((e) => e.order_row)
                    .some((some) => some.order_row.required_serial_number) && (
                      <>
                        <MiniBlock
                          color={"#ffcc69"}
                          action={opennedModalTables.order_serial_number}
                          onChange={() =>
                            updateOpennedModalTables("order_serial_number")
                          }
                        >
                          Serijiniai numeriai
                        </MiniBlock>
                        {opennedModalTables.order_serial_number && (
                          <Divs>
                            <div className="col-12 bg-silver">
                              <SerialNumberBlock
                                orderID={id}
                                updateSerialNumber={async (_, prod_id, param) => {
                                  mutationOrder.mutate({ ...param, id: prod_id });
                                  return true;
                                }}
                                // updateSerialNumberState={(val) => {
                                //   console.log({ val });
                                // }}
                                options={shipment.shipment_order_rows
                                  .filter((e) => e.order_row)
                                  .map((e) => e.order_row)
                                  .filter((filt) => filt.required_serial_number)}
                              />
                            </div>
                          </Divs>
                        )}
                      </>
                    )}

                  <MiniBlock
                    color={"#ffcc69"}
                    action={opennedModalTables.order_status}
                    onChange={() => updateOpennedModalTables("order_status")}
                  >
                    Statusas
                  </MiniBlock>
                  {opennedModalTables.order_status && (
                    <Divs>
                      <div className="col-12 bg-silver">
                        <div className="table-responsive">
                          <table className="table table-sm">
                            <tbody>
                              {order_histories.length > 0 &&
                                order_histories
                                  .reverse()
                                  .map((item) =>
                                    item.status?.technorama ? (
                                      <OrderHistory
                                        key={`order_history_${item.id}`}
                                        item={item}
                                      />
                                    ) : null
                                  )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Divs>
                  )}

                  <React.Fragment>
                    <MiniBlock
                      color={"#ffcc69"}
                      action={opennedModalTables.order_delivery}
                      onChange={() =>
                        updateOpennedModalTables("order_delivery")
                      }
                    >
                      Pristatymas
                    </MiniBlock>
                    {opennedModalTables.order_delivery && (
                      <Divs>
                        <div className="bg-silver col-12 py-3">
                          <div className="col-6 px-0">
                            <div
                              className="text-white font-bold text-xs text-center py-1"
                              style={{
                                borderRadius: 14,
                                backgroundColor: colors["technorama"],
                              }}
                            >
                              Pristatymo kaina:{" "}
                              {returnEuroString(total_shipping)}
                            </div>
                            <div className="text-black text-sm">
                              {shipment.shipment_address && (
                                <div>
                                  Atsiėmimas parduotuvėje:{" "}
                                  <div>
                                    {shipment.shipment_address.address}
                                    {", "}
                                    {shipment.shipment_address.postal_code}
                                    {", "}
                                    {shipment.shipment_address.city}
                                  </div>
                                </div>
                              )}
                              <div>
                                Mokėjimas: <span>{payment}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Divs>
                    )}
                  </React.Fragment>
                  <React.Fragment>
                    <MiniBlock
                      color={"#ffcc69"}
                      action={opennedModalTables.order_payment}
                      onChange={() => updateOpennedModalTables("order_payment")}
                    >
                      Apmokėjimai
                    </MiniBlock>
                    {opennedModalTables.order_payment && (
                      <Divs>
                        <React.Fragment>
                          <div className="table-responsive bg-silver pt-2">
                            <div
                              className="col-12"
                              style={{
                                marginBottom: "1rem",
                              }}
                            >
                              <table
                                className="table table-sm mb-1"
                                style={{ marginBottom: "0px!important" }}
                              >
                                <thead className="border-bottom mb-1">
                                  <tr>
                                    <th className="text-black">Mok. nr.</th>
                                    <th className="text-black w-33">
                                      Mokėjimo būdas
                                    </th>
                                    <th className="text-black w-33">
                                      Vartotojas
                                    </th>
                                    <th className="text-black w-33">Data</th>
                                    <th className="text-black">Suma</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {payments.map((payment) => (
                                    <tr key={`payment_${payment.id}`}>
                                      <td style={{ fontSize: "0.8rem" }}>
                                        {payment.reference}
                                      </td>
                                      <td>{payment.payment_type}</td>
                                      <td>
                                        {payment.user &&
                                          `${payment.user.firstname} ${payment.user.lastname}`}
                                      </td>
                                      <td>
                                        {moment(payment.created_at).format(
                                          "YYYY-MM-DD HH:mm"
                                        )}
                                      </td>
                                      <td>{payment.price}</td>
                                    </tr>
                                  ))}
                                  <tr className="border-top border-bottom mt-1">
                                    <td colSpan="4">Iš viso apmokėta:</td>
                                    <td colSpan="3">{dangerColor()}</td>
                                  </tr>
                                </tbody>
                              </table>

                              {waiting_payments.length == 0 ? (
                                <span
                                  style={{
                                    fontSize: "0.9rem",
                                    paddingLeft: "0.3rem",
                                  }}
                                >
                                  Nėra laukiamų apmokėjimų
                                </span>
                              ) : (
                                <table
                                  className="table table-sm"
                                  style={{ marginBottom: "0px!important" }}
                                >
                                  <thead className="border-bottom mb-1">
                                    <tr>
                                      <th className="text-black">
                                        Paslauga ar prekė
                                      </th>
                                      <th className="text-black w-33">Suma</th>
                                      <th className="text-black w-33">
                                        Išsiuntimo data
                                      </th>
                                      <th className="text-black w-33">
                                        Mokėjimo data
                                      </th>
                                      <th>Statusas</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {waiting_payments.map((payment, index) => (
                                      <tr key={index}>
                                        <td>{payment.service}</td>
                                        <td>
                                          {Number(payment.price).toFixed(2)} €
                                        </td>
                                        <td>
                                          {prettyDateFormat(payment.created_at)}
                                        </td>
                                        <td>
                                          {payment.created_at !==
                                            payment.updated_at &&
                                            prettyDateFormat(
                                              payment.updated_at
                                            )}
                                        </td>
                                        <td>
                                          {payment.status == "unpaid"
                                            ? "Neapmokėta"
                                            : payment.status == "paid_temp"
                                              ? "Mokėjimas inicijuotas"
                                              : "Apmokėta"}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          </div>
                        </React.Fragment>
                      </Divs>
                    )}
                  </React.Fragment>
                </>
              </Divs>
            )}
          </Fragment>

          <Divs>
            <MainBlock
              color={"#BD00FF"}
              action={opennedModalTables.leasing}
              onChange={() => updateOpennedModalTables("leasing")}
            >
              Lizingas
            </MainBlock>

            {opennedModalTables.leasing && (
              <Divs className="bg-silver mb-4 pt-2 pb-3">
                <PickupLeasingComponent
                  disabled={disabled}
                  orderId={id}
                  p_leasing_cod={leasing_cod}
                  p_leasing_number={leasing_number}
                  p_leasing_discount={leasing_discount}
                  p_leasing_advance={leasing_advance}
                />
              </Divs>
            )}
          </Divs>
          <Divs>
            <MainBlock
              color={"#00aaa0"}
              action={opennedModalTables.order_documents}
              onChange={() => updateOpennedModalTables("order_documents")}
            >
              Dokumentai
            </MainBlock>
            {opennedModalTables.order_documents && (
              <Divs className="bg-silver mb-4 pt-2 pb-3">
                <DocumentItem
                  documents={order_documents.filter(
                    (e) => typeof e.internal == "boolean" && e.internal == false
                  )}
                  identifier={"technorama"}
                />
              </Divs>
            )}
          </Divs>
        </div>
        <div className="col-6">
          <RenderComments
            disabled={disabled}
            comments={comments}
            id={showOrderModal.record_id}
            updateOpennedModalTables={updateOpennedModalTables}
            opennedModalTables={opennedModalTables}
          />
          <RenderSms
            disabled={disabled}
            id={showOrderModal.record_id}
            phoneNumber={billing_address.phone}
            shipping_address_street={`${shipment.shipment_address.address}, ${shipment.shipment_address.city}`}
            orderId={id_order}
            shipments={[shipment]}
            sms_sendings={sms_sendings}
            updateOpennedModalTables={updateOpennedModalTables}
            opennedModalTables={opennedModalTables}
          />
        </div>
      </div>
    </ModalSpecial>
  );
};

const TopBar = ({
  record_id,
  status,
  finalized_at,
  shipment,
  id_order,
  billing_address,
  sms_sendings,
  refetch,
  pickup_user,
  user,
}) => {
  const [showPrepared, setShowPrepared] = useState(false);
  const utils = useQueryClient();

  const mutationUpdateStep = useMutation({
    mutationFn: (params = {}) => {
      return Axios.put(`/pickups/requests/${record_id}`, params).then(
        (res) => res.data
      );
    },
    onSuccess: async () => {
      refetch();
      antdMessageSuccess("Sėkmingai atlikta");
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.message);
    },
  });

  const renderBooleanSN = () => {
    if (!finalized_at && !status) return false;
    if (!shipment) return false;

    return shipment?.shipment_order_rows.some((e) => {
      if (!e.order_row) return false;
      const item = e.order_row;
      if (!item.required_serial_number) return false;
      if (item.serial_number) {
        const check_array = shipment.shipment_order_rows
          .filter((e) => e.order_row)
          .map((e) => e.order_row);
        return check_array.find(
          (fi) =>
            fi.serial_number == item.serial_number &&
            fi.id !== item.id &&
            fi.product_reference == item.product_reference
        )
          ? true
          : false;
      }
      return true;
    });
  };

  const mutationPickupCanceled = useMutation({
    mutationFn: () => {
      return Axios.post(`/pickups/requests/${record_id}/canceled`).then(
        (res) => res.data
      );
    },
    onSuccess: async () => {
      await utils.invalidateQueries(["requests", { record_id }]);
      antdMessageSuccess("Sėkmingai atšauktas");
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.message);
    },
  });

  return (
    <div
      className="d-flex justify-content-between align-items-center w-100"
      style={{ borderRight: "2px solid #EDEDED" }}
    >
      <div className="d-flex align-items-center">
        <span className="text-black mr-2">
          Užsakymas <span className="text-orange">#</span>
          {id_order}
        </span>
        {["prepared"].includes(status) && renderBooleanSN() ? (
          <div className="text-danger">
            Negali vykti tolimesni veiksmai, kol neįrašyti tinkamai S/N
          </div>
        ) : (
          <>
            {/* <ButtonSecondary
              style={{
                width: "auto",
              }}
              loading={mutationUpdateStep.isLoading}
              disabled={status !== "unprepared"}
              outline={true}
              bgColor={colors["orange"]}
              bgActiveColor="#FFF"
              onClick={() => mutationUpdateStep.mutate({})}
            >
              Suruošta
            </ButtonSecondary>
            <AiOutlineRight className="mx-2" style={{ color: "#ADADAD" }} />
            <Popover
              placement="bottom"
              onOpenChange={(val) => setShowPrepared(val)}
              onClick={() => {
                setShowPrepared((prev) => !prev);
              }}
              open={status == "prepared" && showPrepared}
              content={
                status == "prepared" && showPrepared ? (
                  <RenderSms
                    id={record_id}
                    phoneNumber={billing_address.phone}
                    shipping_address_street={`${shipment.shipment_address.address}, ${shipment.shipment_address.city}`}
                    orderId={id_order}
                    shipments={[shipment]}
                    sms_sendings={sms_sendings}
                    mode="Simple"
                    update_step={mutationUpdateStep.mutate}
                    closePopover={() => setShowPrepared(false)}
                  />
                ) : (
                  ""
                )
              }
              trigger="click"
            >
              <ButtonSecondary
                style={{
                  width: "auto",
                }}
                loading={mutationUpdateStep.isLoading}
                disabled={status !== "prepared"}
                onClick={() => { }}
                outline={true}
                bgColor={colors["orange"]}
                bgActiveColor="#FFF"
              >
                Iškviesti klientą
              </ButtonSecondary>
            </Popover>
            <AiOutlineRight className="mx-2" style={{ color: "#ADADAD" }} />
            <ButtonSecondary
              style={{
                width: "auto",
              }}
              loading={mutationUpdateStep.isLoading}
              disabled={status !== "client_called" || !!finalized_at}
              onClick={() => mutationUpdateStep.mutate({})}
              outline={true}
              bgColor={colors["orange"]}
              bgActiveColor="#FFF"
            >
              Atiduota
            </ButtonSecondary> */}
            {finalized_at && (
              <Fragment>
                <AiOutlineInfoCircle
                  className="mx-1"
                  style={{ color: "silver" }}
                />
                <small style={{ color: "silver" }}>
                  {pickup_user?.title} {formatDateTime(finalized_at)}
                </small>
              </Fragment>
            )}
          </>
        )}
      </div>
      <div>
        {/* {[1, 2, 3, 4, 5, 6, 20, 22].includes(user.id) && (
          <ButtonSecondary
            disabled={!(status !== "canceled" && !finalized_at)}
            loading={mutationPickupCanceled.isLoading}
            style={{
              width: "auto",
            }}
            // style={{
            //   width: 135,
            // }}
            className="btn btn-sm btn-primary mr-2"
            onClick={() =>
              confirm({
                className: "confirm-technorama",
                title: "Ar tikrai norite atšaukti paėmimą?",
                icon: <IconExclamation colors={colors["technorama"]} />,
                content: "Įvykdžius veiksmą, jo nebebus galima atkurti",
                okText: "Taip",
                cancelText: "Ne",
                okButtonProps: { style: { backgroundColor: "#f7931d" } },
                onOk() {
                  console.log("OK");
                  mutationPickupCanceled.mutate();
                },
                onCancel() {
                  console.log("Cancel");
                },
              })
            }
            bgColor={"#D83B3B"}
            bgActiveColor={"#D83B3B"}
          >
            Atšaukti
          </ButtonSecondary>
        )} */}
        {/* {shipment && (
          <ButtonSecondary
            style={{
              width: "auto",
            }}
            className="btn btn-sm btn-primary mr-2"
            onClick={() =>
              exportDocument(
                `/pickups/requests/download_pickup_at_store?shipment_id=${shipment.id}`,
                `pickup_at_store${id_order}.pdf`,
                "POST"
              )
            }
            bgColor={colors["orange"]}
            bgActiveColor={colors["orange"]}
          >
            <AiOutlineFileExcel className="mr-1" size={18} />
            Atidavimo dokumentas
          </ButtonSecondary>
        )} */}
      </div>
    </div>
  );
};

function OrderTotalComponent({
  total_price,
  payments = [],
  order_with_leasing,
  isShipmentTotalPrice,
}) {
  total_price = toFixedNumber(total_price);

  const total = toFixedNumber(
    payments.length > 0
      ? payments.reduce((acc, cur) => +acc + +cur.price, 0)
      : order_with_leasing
        ? total_price
        : 0
  );

  const equalTo = Number(total) >= Number(total_price);
  const equal = total == total_price;
  const difference = equalTo ? total - +total_price : +total_price - total;

  return (
    <React.Fragment>
      <div className={"text-center"}>
        {equal ? (
          <span className="badge badge-danger badge-left  badge-order-price py-1-5">
            <GoPrimitiveDot className="text-white" size={18} />
            Apmokėta
          </span>
        ) : equalTo ? (
          <>
            {isShipmentTotalPrice && (
              <span className="badge badge-danger badge-left  badge-order-price py-1-5">
                <GoPrimitiveDot className="text-white" size={18} />
                Apmokėta
              </span>
            )}
            <span
              className="badge badge-danger badge-left  badge-order-price py-1-5"
              style={{
                backgroundColor: "#594f4f",
                borderColor: "#594f4f",
                display: isShipmentTotalPrice ? "none" : "inline",
              }}
            >
              <GoPrimitiveDot className="text-white" size={18} />
              Permokėta
            </span>
          </>
        ) : (
          <span className="badge badge-danger badge-left  badge-order-price badge-danger-color py-1-5">
            <GoPrimitiveDot className="text-white" size={18} />
            Neapmokėta
          </span>
        )}
        <span className="badge badge-warning badge-middle  badge-order-price py-1-5">
          Užsakymo kaina: {Number(total_price).toFixed(2)} {"\u20AC"}
        </span>
        <span
          className={`badge badge-success badge-right badge-order-price py-1-5 ${equal ? "invisible" : equalTo ? "invisible" : ""
            }`}
        >
          <GoPrimitiveDot className="text-white" size={18} />
          {Number(difference).toFixed(2)} {"\u20AC"} skirtumas
        </span>
      </div>
    </React.Fragment>
  );
}

const BillingAddressComponent = ({
  disabled,
  billing_address,
  order_invoices,
  pickup_request_id,
  pickup_address_id,
  order_rows,
}) => {
  // validation
  const phonenumber = true;
  const rivile = {
    error: null,
  };
  const utils = useQueryClient();

  const mutationInvoice = useMutation({
    mutationFn: () => {
      return Axios.post(`/pickups/requests/create_invoice`, {
        pickup_request_id,
      }).then((res) => res.data);
    },
    onSuccess: async (res) => {
      if (res.errors) throw new Error(res.errors);
      await utils.invalidateQueries(["requests"]);
      antdMessageSuccess();
    },
    onError: (error) =>
      antdMessageError(
        JSON.stringify(
          error.message ||
          error?.response?.data?.message ||
          error?.response?.data
        )
      ),
  });

  const mutationClient = useMutation({
    mutationFn: () => {
      return Axios.post(`/pickups/requests/register_address`, {
        pickup_address_id,
        pickup_request_id,
      }).then((res) => res.data);
    },
    onSuccess: async (res) => {
      if (res.data.errors) return antdMessageError(res.data.errors);
      await utils.invalidateQueries(["requests"]);
      antdMessageSuccess();
    },
    onError: (error) => antdMessageError(error?.response?.data?.message),
  });

  const filteredOrderInvoices = useMemo(() => {
    const filtered = order_invoices.filter(
      ({ invoice_type, api_errors, identifier, order_invoice_order_rows }) =>
        invoice_type == "TCH" &&
        !api_errors &&
        identifier !== "pre_invoice" &&
        order_invoice_order_rows.some((s) =>
          order_rows.map((d) => d.order_row_id).includes(s.order_row_id)
        )
    );

    const row_ids = filtered
      .map(({ order_invoice_order_rows }) =>
        order_invoice_order_rows.map(({ order_row_id }) => order_row_id)
      )
      .flat();

    const disabled = order_rows.every((order_row) =>
      row_ids.includes(order_row.order_row_id)
    );

    return {
      data: filtered.map((d) => d.invoice_number),
      disabled,
    };
  }, [order_invoices.length]);

  return (
    <React.Fragment>
      <ul className="list-style-none text-sm">
        <li>
          {billing_address.firstname} {billing_address.lastname}
        </li>
        {billing_address.company && <li>{billing_address.company}</li>}
        {billing_address.company_code && (
          <li>{billing_address.company_code}</li>
        )}
        {billing_address.vat_code && <li>PVM: {billing_address.vat_code}</li>}
        <li>{billing_address.street}</li>
        {billing_address.street2 !== null && <li>{billing_address.street2}</li>}
        {billing_address.city || billing_address.postal_code ? (
          <li>
            {billing_address.city && `${billing_address.city}, `}
            {billing_address.postal_code}
          </li>
        ) : null}
        <li className={phonenumber ? "" : "text-danger"}>
          {billing_address.phone}
        </li>
        <li>{billing_address.other}</li>

        <li
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 4,
          }}
        >
          {billing_address.registered_in_rivile ? (
            <div className="d-flex">
              <LongButton
                style={{
                  backgroundColor: "#28a745",
                  color: "white",
                  fontSize: "12px",
                  maxWidth: "150px",
                  height: "auto",
                  width: "auto",
                  padding: "0 13px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                text={"Eksportuota"}
              />
            </div>
          ) : (
            <ButtonSecondary
              disabled={true}
              loading={mutationClient.isLoading}
              onClick={() => mutationClient.mutate()}
              outline={true}
              bgColor={colors["orange"]}
              bgActiveColor="#FFF"
            >
              <GoPrimitiveDot
                style={{
                  color: colors["orange"],
                }}
                size={18}
              />
              <span>Klientas</span>
            </ButtonSecondary>
          )}

          {billing_address.company && !billing_address.company_code ? (
            <div className="text-danger">Neįvestas įmonės kodas</div>
          ) : (
            <Tooltip
              placement="top"
              title={`Išrašytos sąskaitos ${filteredOrderInvoices.data?.length}`}
            >
              <div>
                <ButtonSecondary
                  disabled={disabled || filteredOrderInvoices.disabled}
                  loading={mutationInvoice.isLoading}
                  onClick={() => mutationInvoice.mutate()}
                  outline={true}
                  bgColor={
                    colors[
                    !!filteredOrderInvoices.data?.length
                      ? "success"
                      : "orange"
                    ]
                  }
                  bgActiveColor="#FFF"
                >
                  <GoPrimitiveDot
                    style={{
                      color:
                        colors[
                        !!filteredOrderInvoices.data?.length
                          ? "success"
                          : "orange"
                        ],
                    }}
                    size={18}
                  />
                  <span>Sąskaita</span>
                </ButtonSecondary>
              </div>
            </Tooltip>
          )}
        </li>
        {!!filteredOrderInvoices.data?.length && (
          <li>
            <h5 className="font-medium text-sm mb-0 mt-2">
              Išrašytos sąskaitos
            </h5>
            <ol className="pl-4">
              {filteredOrderInvoices.data.map((value) => (
                <li key={value}>{value}</li>
              ))}
            </ol>
          </li>
        )}
        {rivile.error !== null && (
          <li className="text-danger" style={{ fontSize: "13px" }}>
            {rivile.error.map((item) => (
              <div>{item}</div>
            ))}
          </li>
        )}
      </ul>
    </React.Fragment>
  );
};
